import request from '@/utils/request';

export default {
  // 发送短信验证码
  getCode (data) {
    return request({
      url: '/franchise-api/h5/smsCode',
      data
    });
  },
  // 意向区域
  getAreas (data) {
    return request({
      url: '/franchise-api/h5/areas',
      data
    });
  },
  // 新增意向
  addIntention (data) {
    return request({
      url: '/franchise-api/h5/addIntention',
      data
    });
  }
};
